<div>
  <div class="btn-list">
    <div class="btn-icon">
      <a [routerLink]="editar()" *ngIf="planoAcao?.can_edit">
        <img src="assets/images/svgs/Editar.svg" alt="Editar" tooltip="Editar" placement="bottom">
      </a>
    </div>
    <button type="button" class="btn-back" (click)="voltar()">Voltar</button>
  </div>

  <div class="info-page">
    <h3>Ação</h3>
  </div>

  <div class="list-info" *ngIf="planoAcao?.description_entrega">
    <h4>Entregavel:</h4>
    <p>{{ planoAcao?.description_entrega }}</p>
  </div>

  <div class="list-info" *ngIf="planoAcao?.description_indicador">
    <h4>Indicador:</h4>
    <p>{{ planoAcao?.description_indicador }}</p>
  </div>

  <div class="list-info">
    <h4>Ação:</h4>
    <p>{{ planoAcao?.title }}</p>
  </div>

  <div class="list-info">
    <h4>Descrição:</h4>
    <p>{{ planoAcao?.description }}</p>
  </div>

  <div class="list-info">
    <h4>Início:</h4>
    <p>{{ planoAcao?.dt_start }}</p>
  </div>

  <div class="list-info">
    <h4>Término planejado:</h4>
    <p>{{ planoAcao?.deadline }}</p>
  </div>

  <div class="list-info">
    <h4>Responsável:</h4>
    <p>{{ planoAcao?.resp_nome }}</p>
  </div>
</div>

<div class="header_search m-t-lg">
  <div class="title-page">
    <h3>Situação</h3>
  </div>
  <div class="content_search">
    <div class="new-demand">
      <a class="btn btn-primary" type="btn" [routerLink]="novoSituacao()">Nova Situação</a>
    </div>
  </div>
</div>

<div class="system-table table-container">
  <div class="system-table-conteiner">
    <table>
      <thead>
        <tr>
          <th class="text-center">Status</th>
          <th>Previsão Início</th>
          <th class="text-center">Previsão Conclusão</th>
          <th>Situação</th>
          <th class="text-center">Atualização</th>
          <th>Bloq.</th>
          <th class="text-center btn-icon-td">Ações</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let situacao of planoAcao?.analysis; let i = index">
          <tr>
            <td class="title status">
              <div>
                <div>{{situacao?.situation}}</div>
                <div [innerHTML]="situacao?.status1"></div>
              </div>
            </td>
            <td class="text-center">{{ situacao?.dt_start }}</td>
            <td class="text-center">{{ situacao?.deadline }}</td>
            <td>
              {{situacao?.description}}
            </td>
            <td class="text-center">
              <div class="m-b-xs">{{situacao?.str_nome}}</div>
              {{situacao?.ctr_dth_atu}}
            </td>
            <td>{{ situacao?.action_lockdown_id ? "Sim" : "Não" }}</td>
            <td class="btn-icon-td">
              <div class="btn-icon btn-icon-text">
                <a class="icon-table m-b-sm" [routerLink]="editarSituacao(situacao?.id)" *ngIf="planoAcao?.can_edit_analysis">
                  <img src="assets/images/svgs/lupa.svg" alt="Visualizar" tooltip="Visualizar" placement="bottom">
                </a>
                <span class="icon-table icon-red m-b-sm" (click)="confirmExcluir(situacao?.id)" *ngIf="planoAcao?.can_edit_analysis">
                  <img src="assets/images/svgs/trash.svg" alt="Excluir" tooltip="Excluir" placement="bottom">
                </span>
                <span class="icon-table m-b-sm" (click)="situacao.analysis_active = !situacao?.analysis_active" *ngIf="situacao?.extras?.length">
                  <img src="assets/images/svgs/arrows-{{situacao?.analysis_active ? 'close' : 'open'}}.svg" alt="Mostrar situação" tooltip="Mostrar situação" placement="bottom">
                </span>
                <a class="icon-table icon-table-text m-b-sm" [routerLink]="novaDemandaLink()" [queryParams]="novaDemandaParams(situacao?.id)" *ngIf="planoAcao?.can_demand_analysis">
                  Nova demanda
                </a>
              </div>
            </td>
          </tr>

          <ng-container *ngIf="situacao?.extras?.length && situacao?.analysis_active">
            <tr>
              <td colspan="2"></td>
              <th class="title">Titulo</th>
              <th class="text-center">Unid. Med.</th>
              <th class="text-center">Meta</th>
              <th class="text-center">Realizado</th>
              <th></th>
            </tr>

            <tr *ngFor="let extra of situacao?.extras">
              <td colspan="2"></td>
              <td class="title">{{extra?.title}}</td>
              <td class="text-center">{{extra?.unit_id}}</td>
              <td class="text-center">{{extra?.goal}}</td>
              <td class="text-center">{{extra?.value_done}}</td>
              <td></td>
            </tr>
          </ng-container>
        </ng-container>
        <tr *ngIf="!planoAcao?.analysis?.length" class="border-b-radius">
          <td colspan="7" class="text-center">Nenhuma Situação Cadastrada.</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<app-loading [loader]="isLoading"></app-loading>